/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Checkout button feedback: spinner -> check mark -> go to checkout
  var LOADING_MS = 800;
  var ADDED_MS = 700;
  var busy = false;

  document.addEventListener(
    'click',
    function(event) {
      var button = event.target.closest('button.cart__checkout[name="checkout"]');
      if (!button || busy || button.disabled) return;
      // Let the theme's own terms-acceptance handling run when checkout is gated
      if (button.closest('.cart__buttons--disabled')) return;

      var form = button.form;
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      busy = true;
      button.classList.add('is-loading');

      setTimeout(function() {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        setTimeout(function() {
          // Submit through the button so name="checkout" is sent as usual
          form.requestSubmit(button);
        }, ADDED_MS);
      }, LOADING_MS);
    },
    true
  );

  // Sold-out "Notify me" buttons: spinner -> check mark -> open the notification popup
  var notifyBusy = false;

  document.addEventListener(
    'click',
    function(event) {
      var button = event.target.closest(
        '.product-soldout-notification [data-popup-open], .product-card-soldout-notification [data-popup-open]'
      );
      if (!button || notifyBusy) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      notifyBusy = true;
      button.classList.add('is-loading');

      setTimeout(function() {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        setTimeout(function() {
          // Re-fire the click so the popup component opens the dialog as usual
          button.click();
          button.classList.remove('is-added');
          notifyBusy = false;
        }, ADDED_MS);
      }, LOADING_MS);
    },
    true
  );

  // Restore the button when returning from checkout via the back button (bfcache)
  window.addEventListener('pageshow', function(event) {
    if (!event.persisted) return;
    busy = false;
    document.querySelectorAll('.cart__checkout').forEach(function(el) {
      el.classList.remove('is-loading', 'is-added');
    });
  });





  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
